export default {
  common: {
    error: "เกิดข้อผิดพลาด",
    reload: "โหลดใหม่",
    errorNotification: "เราได้รับการแจ้งเตือนแล้วและจะแก้ไขโดยเร็วที่สุด หากปัญหายังคงอยู่ กรุณา",
    contactUs: "ติดต่อเรา.",
    language: "ภาษา",
    loading: "กำลังโหลด...",
    loadingText: "กำลังโหลด",
    save: "บันทึก",
    savedSuccessfully: "บันทึกสำเร็จ",
    saving: "กำลังบันทึก...",
    cancel: "ยกเลิก",
    edit: "แก้ไข",
    delete: "ลบ",
    add: "เพิ่ม",
    search: "ค้นหา",
    filter: "กรอง",
    clear: "ล้าง",
    preview: "ดูตัวอย่าง",
    default: "ค่าเริ่มต้น: {{value}}",
    optional: "ไม่บังคับ",
    required: "จำเป็น",
    noData: "ไม่มีข้อมูล",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "สถานที่",
      cities: "เมือง",
      regions: "ภูมิภาค",
      countries: "ประเทศ",
      showOnMap: "แสดงบนแผนที่",
      addLocation: "เพิ่มสถานที่"
    },
    welcome: {
      title: "ยินดีต้อนรับสู่ Locations So Super.",
      subtitle: "เลือกส่วนจากเมนูนำทางเพื่อเริ่มต้น."
    }
  },
  // Cities section
  cities: {
    title: "เมือง",
    resourceSingular: "เมือง",
    resourcePlural: "เมือง",
    headings: {
      name: "ชื่อ",
      status: "สถานะ",
      locations: "สถานที่",
      region: "ภูมิภาค",
      country: "ประเทศ"
    },
    breadcrumbs: {
      cities: "เมือง"
    }
  },
  // Countries section
  countries: {
    title: "ประเทศ",
    resourceSingular: "ประเทศ",
    resourcePlural: "ประเทศ",
    headings: {
      name: "ชื่อ",
      status: "สถานะ",
      locations: "สถานที่",
      cities: "เมือง",
      regions: "ภูมิภาค"
    },
    breadcrumbs: {
      countries: "ประเทศ"
    }
  },
  // Regions section
  regions: {
    title: "ภูมิภาค",
    resourceSingular: "ภูมิภาค",
    resourcePlural: "ภูมิภาค",
    headings: {
      name: "ชื่อ",
      status: "สถานะ",
      locations: "สถานที่",
      cities: "เมือง",
      country: "ประเทศ"
    },
    breadcrumbs: {
      regions: "ภูมิภาค"
    }
  },
  // Map section
  map: {
    title: "แผนที่",
    breadcrumbs: {
      locations: "สถานที่"
    }
  },
  // Import section
  import: {
    title: "นำเข้า CSV",
    breadcrumbs: {
      locations: "สถานที่"
    },
    new: {
      title: "นำเข้าสถานที่ด้วย CSV",
      description: "ดาวน์โหลดเทมเพลต CSV ตัวอย่างเพื่อดูตัวอย่างรูปแบบที่ต้องการ",
      sampleTemplate: "เทมเพลต CSV ตัวอย่าง",
      uploadAndContinue: "อัปโหลดและดำเนินการต่อ",
      abortOnError: "หยุดเมื่อเกิดข้อผิดพลาด",
      abortOnErrorHelp: "หากเกิดข้อผิดพลาด การนำเข้าจะหยุด แสดงข้อผิดพลาดและไม่มีการนำเข้าสถานที่ใดๆ",
      needHelp: "ต้องการความช่วยเหลือในการนำเข้าสถานที่?"
    },
    show: {
      title: "การนำเข้า CSV",
      youCanLeavePage: "คุณสามารถออกจากหน้านี้ได้",
      backgroundMessage: "การนำเข้าของคุณจะยังคงทำงานในพื้นหลัง",
      importProgress: "ความคืบหน้าการนำเข้า",
      imported: "นำเข้าแล้ว",
      suffix: "สถานที่",
      importLog: "บันทึกการนำเข้า",
      cancelImport: "ยกเลิกการนำเข้า",
      cancelConfirmation: {
        title: "ยกเลิกการนำเข้า",
        message: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิกงานนำเข้านี้? การดำเนินการนี้ไม่สามารถยกเลิกได้",
        note: "หมายเหตุ: สำหรับงานที่กำลังดำเนินการ งานจะต้องเสร็จสิ้นและจะถูกลบทันทีหลังจากนั้น",
        yesCancel: "ใช่ ยกเลิกการนำเข้า",
        noContinue: "ไม่ ดำเนินการนำเข้าต่อ"
      },
      report: "รายงาน",
      failedLocations: "สถานที่ที่ล้มเหลว",
      uploadAnother: "อัปโหลด CSV อื่น",
      backToLocations: "กลับไปยังสถานที่",
      importSucceeded: "การนำเข้าสำเร็จ",
      importFailed: "การนำเข้าล้มเหลว"
    },
    messages: {
      uploadSuccess: "อัปโหลด CSV สำเร็จ",
      uploadError: "ไม่สามารถอัปโหลด CSV ได้",
      pending: "การนำเข้ายังไม่เริ่ม",
      inProgress: "กำลังนำเข้า",
      completed: "การนำเข้าเสร็จสิ้น",
      invalidHeader: "คอลัมน์ต่อไปนี้จำเป็น",
      invalidCsvFile: "ไฟล์ CSV ไม่ถูกต้อง",
      aborted: "การนำเข้าถูกยกเลิก",
      failed: "การนำเข้าล้มเหลว",
      cancelled: "การนำเข้าถูกยกเลิก"
    },
    errors: {
      csvTooLarge: "ไฟล์ CSV ใหญ่เกินไป",
      languageNotEnabled: "ภาษา '{{language}}' ไม่ได้เปิดใช้งานสำหรับร้านค้านี้ กรุณาเปิดใช้งานใน การตั้งค่า > ภาษา ก่อน",
      fieldNotTranslatable: "ฟิลด์ '{{field}}' ไม่สามารถแปลได้ ฟิลด์ที่สามารถแปลได้คือ: {{fields}}",
      locationError: "สถานที่ที่มี slug: {{slug}} - {{error}}",
      planLimit: "คุณถึงขีดจำกัดแผนสำหรับสถานที่แล้ว"
    }
  },

  // Location form
  location: {
    index: {
      title: "สถานที่",
      addLocation: "เพิ่มสถานที่",
      import: "นำเข้า",
      noPrioritySet: "ไม่มีความสำคัญที่ตั้งไว้",
      published: "เผยแพร่แล้ว",
      draft: "ร่าง",
      resourceSingular: "สถานที่",
      resourcePlural: "สถานที่",
      headings: {
        name: "ชื่อ",
        status: "สถานะ",
        city: "เมือง",
        region: "ภูมิภาค",
        country: "ประเทศ",
        priority: "ความสำคัญ"
      }
    },
    form: {
      title: "เพิ่มสถานที่",
      editTitle: "แก้ไขสถานที่",
      basicInformation: "ข้อมูลพื้นฐาน",
      name: "ชื่อ",
      namePlaceholder: "ตัวอย่าง: Brians Bricks",
      nameHelpDefault: "ค่าเริ่มต้น: {{defaultName}}",
      description: "คำอธิบาย",
      descriptionPlaceholder: "บอกผู้ซื้อว่าสถานที่นี้มีสิ่งอะไรที่เฉพาะตัว",
      address: "ที่อยู่",
      addressPlaceholder: "123 ถนนหลัก, เมือง, ประเทศ",
      addressLine1: "บรรทัดที่ 1",
      addressLine2: "บรรทัดที่ 2",
      details: "รายละเอียด",
      postalZipCode: "รหัสไปรษณีย์ / รหัสไปรษณีย์",
      city: "เมือง",
      stateProvinceRegion: "รัฐ / จังหวัด / ภูมิภาค",
      country: "ประเทศ",
      phone: "โทรศัพท์",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "อีเมล",
      emailPlaceholder: "store@example.com",
      website: "เว็บไซต์",
      websitePlaceholder: "https://www.example.com",
      image: "รูปภาพ",
      imagePlaceholder: "ป้อน URL รูปภาพ",
      status: "สถานะ",
      statusActive: "ใช้งาน",
      statusInactive: "ไม่ใช้งาน",
      statusDraft: "ร่าง",
      priority: "ความสำคัญ",
      priorityHelpText: "สถานที่ที่มีความสำคัญสูงขึ้นจะปรากฏขึ้นก่อนในผลการค้นหา",
      findOnMapButton: "ค้นหาบนแผนที่"
    },
    validation: {
      addressNotFound: "ไม่พบที่อยู่",
      createSuccess: "สร้างสถานที่สำเร็จ",
      updateSuccess: "แก้ไขสถานที่สำเร็จ",
      checkFields: "กรุณาตรวจสอบฟิลด์ของคุณ",
      findOnMap: "กรุณาค้นหาสถานที่ของคุณบนแผนที่ก่อนบันทึก"
    },
    errors: {
      loading: "ข้อผิดพลาดในการโหลดสถานที่"
    },
    actions: {
      save: "บันทึกสถานที่",
      delete: "ลบสถานที่",
      preview: "ดูตัวอย่าง"
    },
    customFields: {
      title: "ฟิลด์ที่กำหนดเอง",
      noCustomFields: "ไม่มีฟิลด์ที่กำหนดเองที่ตั้งค่า",
      configureFields: "ตั้งค่าฟิลด์",
      emptyState: "คุณยังไม่ได้ตั้งค่าฟิลด์ที่กำหนดเอง ฟิลด์ที่กำหนดเองช่วยให้คุณเพิ่มข้อมูลเพิ่มเติมที่เฉพาะตัวของธุรกิจของคุณได้"
    },
    openingHours: {
      title: "เวลาเปิดปิด",
      checkboxLabel: "สถานที่นี้มีเวลาเปิดและปิด",
      statusOpen: "เปิด",
      statusOpen24h: "เปิด 24 ชั่วโมง",
      statusClosed: "ปิด",
      openingTimeLabel: "เวลาเปิด",
      closingTimeLabel: "เวลาปิด",
      days: {
        monday: "วันจันทร์",
        tuesday: "วันอังคาร",
        wednesday: "วันพุธ",
        thursday: "วันพฤหัสบดี",
        friday: "วันศุกร์",
        saturday: "วันเสาร์",
        sunday: "วันอาทิตย์"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "เพิ่มล่าสุด",
        recentlyModified: "แก้ไขล่าสุด"
      },
      filters: {
        status: "สถานะ",
        taggedWith: "แท็กด้วย",
        locationStatus: "สถานะสถานที่",
        noTagsToShow: "ไม่มีแท็กที่แสดง",
        searchPlaceholder: "ค้นหา"
      },
      bulkActions: {
        setPublished: "ตั้งเป็นเผยแพร่",
        setUnpublished: "ตั้งเป็นไม่เผยแพร่",
        setPriority: "ตั้งความสำคัญ",
        deleteLocations: "ลบสถานที่",
        exportCSV: "ส่งออกเป็น CSV"
      },
      appliedFilters: {
        statusIs: "สถานะคือ {{status}}",
        taggedWith: "แท็กด้วย {{tag}}",
        nameIncludes: "ชื่อรวม {{search}}"
      },
      modals: {
        deleteTitle: "ลบสถานที่",
        deleteMessage: "คุณแน่ใจหรือไม่ว่าต้องการลบ {{count}}?",
        deleteMessageAll: "คุณแน่ใจหรือไม่ว่าต้องการลบทั้งหมด?",
        prioritiseTitle: "ตั้งความสำคัญ {{count}} สถานที่",
        prioritiseTitleAll: "ตั้งความสำคัญทั้งหมด",
        delete: "ลบ",
        cancel: "ยกเลิก"
      },
      emptyState: {
        noResultsHeading: "ไม่พบสถานที่ใดๆ",
        noResultsText: "ลองเปลี่ยนตัวกรองหรือคำค้นหา",
        noDataHeading: "เพิ่มสถานที่เพื่อปรับปรุง {{resourcePlural}}",
        addLocation: "เพิ่มสถานที่",
        importFromCSV: "นำเข้าจาก CSV"
      },
      pagination: {
        label: "หน้า {{page}} ของ {{pages}}"
      },
      messages: {
        updatedSuccessfully: "อัปเดตสำเร็จ",
        deletedSuccessfully: "ลบสำเร็จ",
        exportedSuccessfully: "ส่งออกสำเร็จ",
        error: "เกิดข้อผิดพลาดบางอย่าง"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "เนื้อหาหน้า",
    editTemplate: "แก้ไขเทมเพลต SEO",
    pageTitle: "หัวข้อ",
    pageDescription: "คำอธิบาย",
    metaTitle: "หัวข้อ",
    metaDescription: "คำอธิบาย",
    urlHandle: "รหัสจัดการ URL",
    searchEnginePreview: "การตรวจสอบความคืบหน้าค้นหาด้วยคลิกครั้งเดียว",
    editMeta: "แก้ไข Meta",
    previewMeta: "ตรวจสอบ Meta",
    loading: "กำลังโหลด...",
    editingLocaleHelp: "แก้ไขเนื้อหาภาษา {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "เทมเพลต SEO",
    breadcrumbs: {
      seoTemplates: "เทมเพลต SEO"
    },
    template: {
      title: "เทมเพลต {{templateName}} - {{locale}}",
      discardChanges: "ยกเลิกการเปลี่ยนแปลง"
    },
    form: {
      pageContent: "เนื้อหาหน้า",
      searchEnginePreview: "การตรวจสอบความคืบหน้าค้นหาด้วยคลิกครั้งเดียว",
      title: "หัวข้อ",
      description: "คำอธิบาย",
      pageTitle: "หัวข้อหน้า",
      metaDescription: "คำอธิบาย Meta",
      editingLocaleHelp: "แก้ไขการแปลภาษา {{locale}}. ถ้าฟิลด์ว่างเปล่าจะแสดงเนื้อหาจาก {{defaultLocale}}.",
      defaultValue: "ค่าเริ่มต้น: {{value}}"
    },
    language: {
      label: "ภาษา",
      defaultHelp: "นี่คือภาษาหลักของคุณ",
      editingHelp: "แก้ไขการแปลภาษา {{locale}}. ถ้าฟิลด์ว่างเปล่าจะแสดงเนื้อหาจาก {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "ไม่ได้เปิดใช้งานภาษาหลายภาษา",
      enableInSettings: "เปิดใช้งานในการตั้งค่า",
      multipleLanguagesInfo: "เพื่อจัดการเทมเพลต SEO สำหรับภาษาหลายภาษา เปิดการทำงานการแปลภาษาในการตั้งค่าภาษาของคุณ ปัจจุบันแสดงเทมเพลต {{locale}} เฉพาะ"
    },
    badges: {
      errors: "ข้อผิดพลาด!",
      unsaved: "ยังไม่บันทึก"
    },
    messages: {
      saveSuccess: "เทมเพลต SEO บันทึกสำเร็จ",
      saveError: "ไม่สามารถบันทึกเทมเพลตได้",
      error: "ข้อผิดพลาด..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "ข้อมูลพื้นฐาน",
      name: "ชื่อ",
      save: "บันทึก",
      saving: "กำลังบันทึก...",
      cancel: "ยกเลิก",
      yourLocationsIn: "สถานที่ของคุณใน {{name}}",
      tableHeadings: {
        name: "ชื่อ",
        status: "สถานะ",
        city: "เมือง",
        region: "ภูมิภาค",
        country: "ประเทศ"
      },
      resourceName: {
        singular: "สถานที่ใน {{name}}",
        plural: "สถานที่ใน {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "แผนที่",
      tags: "แท็ก",
      customFields: "ฟิลด์ที่กำหนดเอง",
      languages: "ภาษา",
      plan: "แผน",
      addTag: "เพิ่มแท็ก",
      addField: "เพิ่มฟิลด์"
    },
    planBadges: {
      trial: "!",
      endsSoon: "จะหมดอายุเร็วๆ"
    },
    common: {
      loading: "กำลังโหลด...",
      error: "ข้อผิดพลาด...",
      breadcrumbs: {
        settings: "การตั้งค่า"
      },
      skeleton: {
        customFields: "ฟิลด์ที่กำหนดเอง",
        addField: "เพิ่มฟิลด์",
        name: "ชื่อ",
        contentType: "ประเภทเนื้อหา",
        usedIn: "ใช้งานใน",
        field: "ฟิลด์",
        fields: "ฟิลด์"
      },
      messages: {
        savedSuccessfully: "{{setting}} การตั้งค่าบันทึกสำเร็จ",
        couldntSave: "ไม่สามารถบันทึก {{setting}} การตั้งค่าได้"
      }
    },
    map: {
      title: "แผนที่",
      messages: {
        savedSuccessfully: "การตั้งค่าแผนที่บันทึกสำเร็จ",
        couldntSave: "ไม่สามารถบันทึกการตั้งค่าได้"
      },
      mapboxToken: {
        title: "คีย์ Mapbox",
        description: "ป้อนคีย์ Mapbox ของคุณเพื่อให้แผนที่ตำแหน่งร้านค้าของคุณทำงาน",
        label: "คีย์ Mapbox",
        placeholder: "ป้อนคีย์นี้เพื่อดำเนินการต่อโดยใช้แผนที่ของคุณ",
        placeholderManaged: "ป้อนคีย์นี้เพื่อดำเนินการต่อโดยใช้แผนที่ของคุณเมื่อคุณใช้ครบจำนวนฟรีของแผนที่",
        helpText: "ติดตามคำแนะนำสำหรับการสร้างคีย์ Mapbox แล้วคัดลอกคีย์ของคุณข้างบน หากคุณพบปัญหาใดๆ โปรดติดต่อเราสำหรับความช่วยเหลือ",
        linkInstructions: "คำแนะนำสำหรับการสร้างคีย์ Mapbox",
        linkSupport: "ติดต่อเราสำหรับความช่วยเหลือ"
      },
      managedToken: {
        title: "การโหลดแผนที่",
        description: "คุณมีถึง {{max}} การโหลดแผนที่ฟรีด้วยคีย์จัดการ หลังจากนั้นคุณจะต้องสร้างคีย์ของตัวเอง"
      },
      appearance: {
        title: "ลักษณะที่ปรากฏบนแผนที่",
        description: "เปลี่ยนแปลงลักษณะที่ปรากฏบนแผนที่"
      },
      mapStyle: {
        title: "สไตล์แผนที่",
        options: {
          streets: "ถนน",
          outdoors: "ภูมิภาค",
          light: "สว่าง",
          dark: "มืด",
          satellite: "ดาวเทียม",
          satelliteStreets: "ดาวเทียมและถนน",
          navigationDay: "ประวัติศาสตร์วัน",
          navigationNight: "ประวัติศาสตร์คืน"
        }
      },
      searchBehaviour: {
        title: "พฤติกรรมการค้นหา",
        description: "ควบคุมวิธีการผู้ใช้งานค้นหาสถานที่บนแผนที่ของคุณ",
        geolocateLabel: "ประมวลผลตำแหน่งที่ตั้งของผู้ใช้และแสดงสถานที่ใกล้เคียง",
        geolocateHelp: "หากการประมวลผลตำแหน่งสำเร็จ แผนที่จะเคลื่อนที่ไปที่ตำแหน่งที่ใกล้เคียงของผู้ใช้ หากไม่พบตำแหน่งที่ประมาณการ แผนที่จะยังคงอยู่ที่ตำแหน่งเริ่มต้น",
        filterBehaviour: {
          title: "พฤติกรรมการกรอง",
          all: {
            label: "แท็กทั้งหมด",
            help: "สำหรับสถานที่ให้ปรากฏในตัวกรอง จำเป็นต้องมีแท็กทั้งหมดที่เลือก"
          },
          any: {
            label: "แท็กใดๆ",
            help: "สำหรับสถานที่ให้ปรากฏในตัวกรอง สามารถมีแท็กใดก็ได้ที่เลือก"
          }
        },
        keepSearchInView: {
          label: "เก็บตัวคลื่นค้นหาในมุมมอง",
          help: "เมื่อผลการค้นหาปรากฏขึ้น แผนที่จะซูมออกเพื่อแสดงสถานที่ทั้งหมดที่ตรงกัน"
        },
        distanceUnits: {
          title: "หน่วยระยะทาง",
          km: "กิโลเมตร",
          miles: "ไมล์"
        },
        maxResults: {
          label: "ผลลัพธ์สูงสุด",
          help: "จำกัดจำนวนสถานที่ที่แสดงในผลการค้นหา",
          options: {
            results30: "30 ผลลัพธ์"
          }
        },
        maxDistance: {
          label: "ระยะทางสูงสุด",
          help: "แสดงสถานที่ที่อยู่ภายในระยะทางนี้จากจุดค้นหา",
          options: {
            unlimited: "ไม่จำกัด"
          }
        },
        showLocationNames: {
          label: "แสดงชื่อสถานที่ในคำแนะนำ",
          help: "แสดงชื่อสถานที่ในคำแนะนำการค้นหา"
        },
        sortByPriority: {
          label: "เรียงตามความสำคัญแทนระยะทาง",
          help: "ควรตั้งค่าระยะทางสูงสุด (ที่ไม่ใช่ไม่จำกัด) หากกล่องนี้เลือก มิฉะนั้นผู้ใช้จะเห็นสถานที่ที่อยู่ไกลมากที่มีความสำคัญสูงกว่าที่อยู่ใกล้กับพวกเขา (หรือคำค้นหาของพวกเขา ความหมายเฉพาะมากขึ้น)"
        }
      },
      searchResults: {
        title: "ผลการค้นหา",
        description: "ควบคุมวิธีการส่งคืนสถานที่บนแผนที่ของคุณ",
        locationsLabel: "ข้อความผลการค้นหา",
        locationsHelp: "ข้อความที่แสดงก่อนผลการค้นหา (ตัวอย่างเช่น 'แสดง 5 สถานที่')",
        prefixLabel: "ข้อความก่อนจำนวนผลลัพธ์",
        prefixHelp: "ข้อความที่แสดงก่อนจำนวนผลลัพธ์"
      },
      popups: {
        title: "กระดาษคำแนะนำ",
        showPopups: {
          label: "แสดงกระดาษคำแนะนำ",
          help: "แสดงรายละเอียดของสถานที่เมื่อผู้ใช้คลิกบนเครื่องหมายจุดบนแผนที่"
        }
             },
       whitelabel: {
         title: "แบรนด์สี่สี",
         hideLabel: "ซ่อนข้อความที่อนุญาตให้ผู้ใช้งาน",
         hideHelp: "ลบแบรนด์ของเราออกจากแผนที่ตำแหน่งร้านค้าของคุณ"
       }
    },
    languages: {
      title: "ภาษา",
      error: "ข้อผิดพลาด...",
      messages: {
        savedSuccessfully: "การตั้งค่าภาษาบันทึกสำเร็จ",
        couldntSave: "ไม่สามารถบันทึกการตั้งค่าภาษาได้"
      },
      banner: {
        upgradeTitle: "การสนับสนุนภาษาหลายภาษาต้องการการอัปเกรดแผน",
        upgradeAction: "อัปเกรดเป็น Superest",
        upgradeMessage: "คุณยังสามารถเปลี่ยนภาษาหลักของคุณได้ แต่การเปิดใช้งานภาษาหลายภาษาต้องการการอัปเกรด",
        disabledMessage: "การตั้งค่าภาษาหลายภาษาถูกปิดใช้งานในแผนปัจจุบันของคุณ"
      },
      defaultLanguage: {
        title: "ภาษาหลัก",
        description: "เลือกภาษาหลักที่คุณต้องการให้เนื้อหาปรากฏ",
        label: "ภาษาหลัก",
        help: "ภาษานี้จะใช้เมื่อไม่มีภาษาที่ร้องขอเฉพาะ"
      },
      internationalization: {
        title: "การแปลภาษา",
        description: "เปิดใช้งานภาษาหลายภาษา ดำเนินการธุรกิจของคุณและปรับปรุง SEO",
        enableLabel: "เปิดใช้งานภาษาหลายภาษา",
        enableHelp: "อนุญาตให้ผู้ใช้ดูแผนที่ตำแหน่งร้านค้าของคุณในภาษาต่างๆ"
      },
      supportedLanguages: {
        title: "ภาษาที่สนับสนุนเพิ่มเติม",
        description: "เลือกภาษาที่คุณต้องการสนับสนุน เมื่อคุณเปิดใช้งานภาษาแล้ว คุณจะเห็นตัวเลือกเพื่อให้แปลทั่วทุกส่วนของแอปพลิเคชัน สำหรับภาษาที่สนับสนุน เทมเพลต SEO ทั่วไป และธีมตัวแปรทั่วไปจะถูกสร้างขึ้นอัตโนมัติ",
        defaultLocaleNote: "นี่คือภาษาหลักของคุณและไม่สามารถปิดใช้งานได้",
        shopifyEnabled: {
          label: "ภาษานี้เปิดใช้งานในร้านค้าของ Shopify ของฉัน",
          importantNote: "สำคัญ:",
          description: "ยกเลิกกล่องด้านบนหากภาษานี้ไม่ได้เปิดใช้งานและเผยแพร่สำหรับร้านค้าของ Shopify ของคุณ ควรเปิดใช้งานภาษาสำหรับร้านค้าของ Shopify ของคุณก่อนโดยไปที่ การตั้งค่า > ภาษา ในคอนโซล Shopify ของคุณหากยังไม่ได้ทำ"
        },
        urlFormats: {
          cleanUrls: "URL ที่สะอาด:",
          betterSeo: "SEO และประสบการณ์ผู้ใช้ที่ดีขึ้น",
          queryUrls: "URL พารามิเตอร์คำค้นหา:",
          considerEnabling: "พิจารณาเปิดใช้งานใน Shopify สำหรับ URL ที่ดีขึ้น"
        },
        preview: {
          button: "ดูตัวอย่าง",
          tooltip: "ดูตัวอย่างแผนที่ตำแหน่งร้านค้า {{language}}"
        },
        tooltips: {
          noTemplates: "ไม่มีเทมเพลต SEO ค่าเริ่มต้นสำหรับภาษานี้ คุณสามารถสร้างแปลภาษาที่กำหนดเองได้ง่าย"
        }
      }
    },
    tags: {
      title: "แท็ก",
      addTag: "เพิ่มแท็ก",
      error: "ข้อผิดพลาด",
      messages: {
        deletedSuccessfully: "แท็กลบสำเร็จ",
        couldntDelete: "ไม่สามารถลบแท็กได้",
        savedSuccessfully: "แท็กบันทึกสำเร็จ",
        couldntSave: "กรุณาตรวจสอบฟิลด์ของคุณ",
        tagDeleted: "แท็กลบสำเร็จ"
      },
      resourceName: {
        singular: "แท็ก",
        plural: "แท็ก"
      },
      filters: {
        anyGroup: "กลุ่มใดๆ",
        inGroup: "ในกลุ่ม",
        tagGroup: "กลุ่มแท็ก"
      },
      appliedFilters: {
        inGroup: "ในกลุ่ม {{group}}",
        nameContains: "ชื่อแท็กมีคำค้นหา {{query}}"
      },
      bulkActions: {
        deleteTag: "ลบแท็ก",
        deleteTags: "ลบแท็ก"
      },
      form: {
        language: "ภาษา",
        title: "หัวข้อ",
        description: "คำอธิบาย",
        group: "กลุ่ม",
        groupPlaceholder: "เลือกกลุ่ม",
        addGroup: "เพิ่ม",
        editingTranslations: "แก้ไขการแปลภาษา {{language}}. ถ้าฟิลด์ว่างเปล่าจะแสดงเนื้อหาจาก {{defaultLanguage}}.",
        defaultValue: "ค่าเริ่มต้น: {{value}}",
        image: "รูปภาพ",
        imageUrl: "URL รูปภาพ"
      },
      actions: {
        save: "บันทึก",
        deleteTag: "ลบแท็ก"
      },
      new: {
        title: "เพิ่มแท็ก",
        messages: {
          createSuccess: "แท็กสร้างสำเร็จ",
          checkFields: "กรุณาตรวจสอบฟิลด์ของคุณ"
        },
        actions: {
          createTag: "สร้างแท็ก"
        }
      }
    },
    customFields: {
      title: "ฟิลด์ที่กำหนดเอง",
      addField: "เพิ่มฟิลด์",
      error: "ข้อผิดพลาด",
      resourceName: {
        singular: "ฟิลด์",
        plural: "ฟิลด์"
      },
      headings: {
        name: "ชื่อ",
        contentType: "ประเภทเนื้อหา",
        usedIn: "ใช้งานใน"
      },
      emptyState: {
        heading: "สร้างและจัดการฟิลด์ที่กำหนดเองของคุณ",
        createAction: "สร้างฟิลด์",
        description: "ใช้ฟิลด์ที่กำหนดเองสำหรับคุณลักษณะเฉพาะของธุรกิจของคุณ ฟิลด์เหล่านี้สามารถเป็นข้อมูลเชิงสังคมหรือชื่อผู้จัดการร้านและอีเมล"
      },
      pluralization: {
        location: "สถานที่",
        locations: "สถานที่"
      },
      form: {
        name: "ชื่อ",
        contentType: "ประเภทเนื้อหา",
        key: "คีย์",
        keyPrefix: "location.fields.",
        keyHelp: "ใช้คีย์นี้เพื่อเข้าถึงเนื้อหาของสถานที่ {{name}} ในเทมเพลตของคุณ",
        translations: {
          title: "แปลภาษา",
          showTranslations: "แสดงแปลภาษา",
          hideTranslations: "ซ่อนแปลภาษา",
          description: "แปลภาษาเป็นได้ ถ้าฟิลด์ว่างเปล่าจะแสดงชื่อฟิลด์ภาษา {{language}}.",
          nameTranslation: "ชื่อ ({{language}})",
          defaultValue: "ค่าเริ่มต้น: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "ฟิลด์บันทึกสำเร็จ",
        couldntSave: "ไม่สามารถบันทึกฟิลด์ได้",
        deletedSuccessfully: "ฟิลด์ลบสำเร็จ",
        couldntDelete: "ไม่สามารถลบฟิลด์ได้"
      },
      actions: {
        delete: "ลบ"
      },
      new: {
        title: "เพิ่มฟิลด์",
        messages: {
          savedSuccessfully: "ฟิลด์บันทึกสำเร็จ",
          couldntSave: "ไม่สามารถบันทึกฟิลด์ได้"
        }
      },
      contentTypes: {
        text: "ข้อความ",
        textArea: "ข้อความพื้นที่",
        email: "อีเมล",
        number: "ตัวเลข",
        phoneNumber: "เบอร์โทรศัพท์",
        time: "เวลา",
        url: "URL"
      }
    },
    plan: {
      title: "แผน",
      error: "ข้อผิดพลาด",
      changePlan: "เปลี่ยนแผน",
      usdPerMonth: "USD / เดือน",
      sections: {
        yourPlanIncludes: "แผนของคุณรวม",
        nextBillingDate: "วันที่การจัดชำระครั้งถัดไป",
        trial: "ทดลองใช้"
      },
      banners: {
        planUpdated: "แผนของคุณได้ถูกอัปเดต",
        thankYouUpgrading: "ขอขอบคุณที่อัปเกรด!",
        letUsKnow: "ปล่อยให้เราทราบ",
        improvementText: "ถ้ามีสิ่งใดที่เราสามารถทำให้ดีขึ้น",
        trialCancellation: {
          title: "แจ้งเตือนการยกเลิกการทดลองใช้",
          message: "การทดลองใช้ฟรี 14 วันของคุณจะถูกยกเลิกเมื่อคุณอัปเกรดเป็นแผนแบบชำระเงิน"
        }
      },
      locations: {
        upTo: "ถึง",
        locations: "สถานที่",
        unlimited: "สถานที่ไม่จำกัด",
        used: "ใช้",
        ofUsed: "{{used}} ของ {{max}} ใช้"
      },
      trial: {
        daysLeft: "{{days}} วันที่เหลือ",
        daysUsed: "{{used}} ของ {{total}} วันใช้",
        selectPlan: "เลือกแผน",
        currentPlan: "แผนปัจจุบัน",
        trialBadge: "ทดลองใช้",
        currentBadge: "ปัจจุบัน",
        yourTrialJustStarted: "ทดลองใช้ของคุณเพิ่งเริ่ม",
        trialEndsAfterToday: "ทดลองใช้ของคุณจะหมดอายุหลังวันนี้",
        trialEndsTomorrow: "ทดลองใช้ของคุณจะหมดอายุพรุ่งนี้",
        daysLeftInTrial: "{{days}} วันที่เหลือในทดลองใช้ของคุณ",
        continueAddingLocations: "ดำเนินการเพิ่มสถานที่หลัง {{date}} โดยเลือกแผน",
        selectPlanToday: "กรุณาเลือกแผนวันนี้เพื่อดำเนินการเพิ่มสถานที่"
      },
      footer: {
        description: "จัดการหรือเปลี่ยนแผนของ Locations So Super ของคุณ ดูเงื่อนไขการใช้งานของเรา",
        termsOfService: "เงื่อนไขการใช้งาน",
        and: "และ",
        privacyPolicy: "นโยบายความเป็นส่วนตัว"
      },
      features: {
        analytics: {
          title: "การวิเคราะห์",
          description: "หาว่าผู้ใช้งานคุณตำแหน่งของคุณและที่พวกเขากำลังค้นหา"
        },
        internationalization: {
          title: "การสนับสนุนภาษาหลายภาษา",
          description: "ปรับปรุง SEO และดำเนินการธุรกิจของคุณในตลาดเป้าหมายโดยเปิดใช้งานภาษาหลายภาษา"
        },
        customThemes: {
          editLiquid: {
            title: "แก้ไขเทมเพลตของธีมของข้อความของธีม",
            description: "แสดงข้อมูลสถานที่ในทางที่คุณต้องการด้วยการเข้าถึงของธีมของข้อความ"
          },
          editStructuredData: {
            title: "แก้ไขข้อมูลทางโครงสร้างธุรกิจ",
            description: "แก้ไขวิธีที่ Google เข้าใจหน้าทั้งหมดโดยแก้ไขข้อมูลทางโครงสร้าง"
          }
        }
      },
      edit: {
        title: "เปลี่ยนแผน",
        allPlansInclude: "แผนทั้งหมดรวมถึง",
        needingMoreLocations: "ต้องการสถานที่เพิ่มเติม?",
        footerQuestion: "มีคำถามก่อนที่คุณจะเริ่ม?",
        sendMessage: "ส่งข้อความให้เรา",
        allFeatures: {
          seoDirectory: {
            title: "ไดเรกทอรีและหน้าคลินิกที่ลงทะเบียน",
            description: "สร้างไดเรกทอรี SEO ทั้งหมดของสถานที่ของคุณ เมืองและภูมิภาค"
          },
          mapPage: {
            title: "หน้าแผนที่ด้วยการค้นหาและการกรอง",
            description: "ค้นหาและกรองสถานที่ทั้งหมดบนแผนที่ที่รองรับด้วยแผนที่ Mapbox"
          },
          tags: {
            title: "แท็ก",
            description: "สร้างแท็กด้วยรูปภาพและคำอธิบายและจัดกลุ่มพวกเขา"
          },
          openingHours: {
            title: "เวลาเปิดปิด",
            description: "ตั้งและแสดงเวลาเปิดปิดสำหรับสถานที่ของคุณ"
          },
          mapStyles: {
            title: "สไตล์แผนที่",
            description: "เปลี่ยนลักษณะที่ปรากฏของแผนที่ด้วยจำนวนสไตล์ที่กำหนดเอง"
          },
          customFields: {
            title: "ฟิลด์ที่กำหนดเอง",
            description: "เพิ่มฟิลด์ที่คุณต้องการ จากลิงก์สังคมถึงชื่อผู้จัดการร้าน"
          },
          csvUpload: {
            title: "อัปโหลดและส่งออกด้วย CSV",
            description: "อัปโหลดและแก้ไขสถานที่ด้วยการบันทึกแบบหลายรายการ"
          },
          richSnippets: {
            title: "ซิปป์ริคิตสำหรับ Google",
            description: "ช่วยให้ Google เข้าใจหน้าทั้งหมดด้วยข้อมูลทางโครงสร้างธุรกิจที่ใช้ท้องถิ่น"
          },
          directionsAndCalls: {
            title: "คำแนะนำและโทรศัพท์",
            description: "ผู้ใช้งานสามารถค้นหาคำแนะนำและโทรศัพท์ได้ง่ายสำหรับสถานที่"
          },
          languageSupport: {
            title: "การสนับสนุนภาษา",
            description: "เปลี่ยนภาษาหลักเป็นภาษาอื่นที่ไม่ใช่ภาษาอังกฤษ แปลภาษาเทมเพลตที่ให้มีความพร้อมตั้งแต่ภาษาหลัก 32 ภาษาหลักสำหรับการตั้งค่าที่ง่าย"
          }
        }
      },
      planCard: {
        bestToCustomize: "ดีที่จะปรับแต่ง",
        currentPlan: "แผนปัจจุบัน",
        chooseThisPlan: "เลือกแผนนี้",
        locationsSection: "สถานที่",
        featuresSection: "คุณสมบัติ",
        upTo: "ถึง",
        locations: "สถานที่",
        tooltipTooManyLocations: "คุณมีสถานที่มากหรือภาษาที่เปิดใช้งานมากสำหรับแผนนี้"
      },
      confirmation: {
        error: "การยืนยันแผนผิดพลาด"
      }
    }
  },

  // Themes section
  themes: {
    title: "ธีม",
    currentTheme: {
      title: "ธีมปัจจุบัน",
      description: "นี่คือธีมที่ผู้ใช้งานเห็นเมื่อเข้าถึงแอปพลิเคชันตำแหน่งของคุณ"
    },
    themeLibrary: {
      title: "เทมเพลตธีม",
      description: "จัดการเทมเพลตธีมของสถานที่ของคุณ เพิ่มและเผยแพร่เทมเพลตเพื่อเปลี่ยนลักษณะที่ปรากฏของตำแหน่งออนไลน์ของคุณ"
    },
    skeleton: {
      currentThemeDescription: "นี่คือธีมที่ผู้ใช้งานเห็นเมื่อเข้าถึงแอปพลิเคชันตำแหน่งของคุณ"
    },
    modal: {
      overrideTitle: "เข้าถึงธีมปัจจุบัน?",
      override: "เข้าถึง",
      cancel: "ยกเลิก",
      undoWarning: "การดำเนินการนี้ไม่สามารถยกเลิกได้"
    },
    messages: {
      publishSuccess: "เทมเพลตเผยแพร่สำเร็จ",
      publishError: "ไม่สามารถเผยแพร่เทมเพลตได้",
      error: "เกิดข้อผิดพลาดบางอย่าง"
    },
    emptyStates: {
      settings: {
        heading: "ธีมนี้ไม่มีการตั้งค่า",
        description: "สร้างการตั้งค่าในผู้แก้ไขเทมเพลต",
        createSettings: "สร้างการตั้งค่า",
        upgradePlan: "อัปเกรดแผน",
        upgradeRequired: "อัปเกรดแผนเพื่อสร้างการตั้งค่า"
      },
      language: {
        heading: "ธีมนี้ไม่มีเทมเพลตข้อความภาษา",
        description: "สร้างเทมเพลตข้อความภาษาในผู้แก้ไขเทมเพลต",
        createLanguageTerms: "สร้างเทมเพลตข้อความภาษา",
        upgradePlan: "อัปเกรดแผน",
        upgradeRequired: "อัปเกรดแผนเพื่อสร้างเทมเพลตข้อความภาษา"
      }
    },
    templates: {
      categories: {
        templates: "เทมเพลต",
        schemas: "โครงสร้าง",
        styles: "สไตล์",
        liquidReference: "การอ้างอิงข้อความของข้อความ"
      },
      items: {
        landing: "หน้าคลินิก",
        directory: "ไดเรกทอรี",
        country: "ประเทศ",
        region: "ภูมิภาค",
        city: "เมือง",
        location: "สถานที่",
        language: "ภาษา",
        settings: "การตั้งค่า",
        stylesheet: "เวิร์คชีท"
      },
      errors: {
        errorsInTemplate: "ข้อผิดพลาดในเทมเพลต",
        error: "ข้อผิดพลาด"
      },
      badges: {
        errors: "ข้อผิดพลาด!",
        unsaved: "ยังไม่บันทึก"
      },
      actions: {
        viewTheme: "ดูธีม",
        discard: "ยกเลิก",
        save: "บันทึก"
      }
    },
    language: {
      messages: {
        saveSuccess: "การแปลภาษาเทมเพลตบันทึกสำเร็จ",
        saveError: "ไม่สามารถบันทึกเทมเพลตได้"
      },
      form: {
        language: "ภาษา",
        defaultLanguageHelp: "นี่คือภาษาหลักของคุณ",
        translationHelp: "แก้ไขการแปลภาษา {{selectedLocale}}. ถ้าฟิลด์ว่างเปล่าจะแสดงเนื้อหาจาก {{defaultLocale}} (ภาษาหลักของคุณ)"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "ไม่ได้เปิดใช้งานภาษาหลายภาษา",
          action: "เปิดใช้งานในการตั้งค่า",
          description: "เพื่อจัดการการแปลภาษา เปิดการทำงานการแปลภาษาในการตั้งค่าภาษาของคุณ ปัจจุบันแสดงเทมเพลตแปลภาษา {{locale}} เฉพาะ"
        },
        translating: {
          title: "แปลจาก {{from}} เป็น {{to}}",
          description: "ถ้าฟิลด์ว่างเปล่าจะแสดงเนื้อหาของผู้ใช้ภาษา {{defaultLocale}} อัตโนมัติ แต่ต้องแปลเฉพาะฟิลด์ที่ต้องการเนื้อหาแตกต่างกันใน {{selectedLocale}}"
        }
      },
      accessLanguageTerms: "เข้าถึงเทมเพลตข้อความภาษา {{category}} ด้วย {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "หัวข้อ",
        description: "คำอธิบาย",
        heading: "หัวข้อ",
        subheading: "หัวข้อย่อย",
        button_text: "ข้อความปุ่ม",
        link_text: "ข้อความลิงก์",
        placeholder: "สถานที่ว่าง",
        label: "ป้ายชื่อ",
        help_text: "ข้อความช่วยเหลือ",
        error_message: "ข้อความข้อผิดพลาด",
        success_message: "ข้อความสำเร็จ",

        // Opening hours
        Monday: "วันจันทร์",
        Tuesday: "วันอังคาร",
        Wednesday: "วันพุธ",
        Thursday: "วันพฤหัสบดี",
        Friday: "วันศุกร์",
        Saturday: "วันเสาร์",
        Sunday: "วันอาทิตย์",
        opening_hours_format: "รูปแบบเวลาเปิดปิด",
        closes_at_format: "รูปแบบปิดที่",
        opens_at_format: "รูปแบบเปิดที่",
        opens_on: "เปิดที่",
        open_24h: "เปิด 24 ชั่วโมง",
        open: "เปิด",
        closed: "ปิด",
        closes_at: "ปิดที่",
        opens_at: "เปิดที่",

        // Map
        search_map: "ค้นหาแผนที่",
        search_area: "ค้นหาพื้นที่นี้",
        view_map: "แผนที่",
        view_list: "รายการ",
        open_filters: "ตัวกรอง",
        stores_near_you: "ร้านค้าที่ใกล้เคียง",
        header: "ค้นหาร้านค้า!",
        search_placeholder: "พิมพ์รหัสไปรษณีย์หรือที่อยู่...",
        no_listings: "เราโอนย้ายโลก เราไม่พบสถานที่ใดๆ สำหรับคำค้นหาของคุณ ลองเปลี่ยนตัวกรองหรือตำแหน่งคำค้นหา",

        // Directory
        view_directory: "ไดเรกทอรีร้านค้า",

        // Location
        get_directions: "คำแนะนำ",
        call: "โทรศัพท์",
        view_website: "เว็บไซต์",
        email: "อีเมล",
        opening_hours_header: "เวลาเปิดปิด",
        description_header: "ข้อมูล",
        phone_number_header: "เบอร์โทรศัพท์",
        address_header: "ที่อยู่",
        tag_groups_to_display: "แท็กกลุ่มที่แสดง"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "ทั่วไป",
        navigation: "นำทาง",
        forms: "ฟอร์ม",
        buttons: "ปุ่ม",
        messages: "ข้อความ",
        errors: "ข้อผิดพลาด",
        opening_hours: "เวลาเปิดปิด",
        map: "แผนที่",
        directory: "ไดเรกทอรี",
        location: "สถานที่"
      }
    },
    settings: {
      messages: {
        saveSuccess: "ธีมบันทึกสำเร็จ",
        saveError: "ไม่สามารถบันทึกธีมได้"
      },
      accessSettings: "เข้าถึงการตั้งค่า {{category}} ด้วย {{code}}",
      fields: {
        // Colors
        color_text: "สีข้อความ",
        color_text_heading: "สีหัวข้อข้อความ",
        color_background: "สีพื้นหลัง",
        color_accent: "สีการเน้น",
        color_text_positive: "สีข้อความบวก",
        color_text_negative: "สีข้อความลบ",
        dark_theme: "ธีมมืด",
        color_marker: "สีเครื่องหมาย",
        color_search_marker: "สีเครื่องหมายค้นหา",

        // Typography
        base_font_size: "ขนาดตัวอักษรพื้นฐาน",

        // Buttons
        border_radius: "ความกระด้างของขอบ",

        // Images
        aspect_ratio: "อัตราส่วนความสูงต่อความกว้าง",
        fit: "ปรับขนาด",

        // Spacing
        page_width: "ความกว้างของหน้า",
        page_width_small: "ความกว้างของหน้าน้อย",
        gutter_desktop: "ระยะห่างด้านนอกบน",
        gutter_mobile: "ระยะห่างด้านนอกมือถือ",
        desktop_vertical_spacing: "ระยะห่างแนวตั้งบน",
        mobile_vertical_spacing: "ระยะห่างแนวตั้งมือถือ",

        // Breakpoints
        breakpoint_xs: "จุดคัดขวาง XS",
        breakpoint_sm: "จุดคัดขวาง SM",
        breakpoint_md: "จุดคัดขวาง MD",

        // Map
        search_on_move: "ค้นหาขณะเคลื่อนที่",
        scroll_to_zoom: "ซูมด้วยการพิมพ์",

        // Landing page
        sidebar_width: "ความกว้างด้านข้าง",
        sidebar_min_height: "ความสูงน้อยที่สุดของด้านข้าง",
        marker_image_src: "แหล่งที่มาของรูปเครื่องหมาย",
        show_filter_descriptions: "แสดงคำอธิบายตัวกรอง",

        // Location page
        tag_groups_to_display: "แท็กกลุ่มที่แสดง",
        tag_groups_to_display_as_icons: "แท็กกลุ่มที่แสดงเป็นไอคอน",
        show_related_locations: "แสดงสถานที่ที่เกี่ยวข้อง",

        // Locations
        hide_regions: "ซ่อนภูมิภาค"
      },
      categories: {
        colors: "สี",
        typography: "ธีม",
        buttons: "ปุ่ม",
        images: "รูปภาพ",
        spacing: "ระยะห่าง",
        breakpoints: "จุดคัดขวาง",
        map: "แผนที่",
        landing_page: "หน้าคลินิก",
        location_page: "หน้าสถานที่",
        locations: "สถานที่"
      }
    },
    navigation: {
      sublimeTheme: "ธีม Sublime",
      settings: "การตั้งค่า",
      language: "ภาษา",
      templates: "เทมเพลต",
      changeTheme: "เปลี่ยนธีม",
      viewDirectory: "ดูไดเรกทอรี",
      viewLandingPage: "ดูหน้าคลินิก"
    },
    card: {
      lastUpdated: "อัปเดตล่าสุด",
      view: "ดู",
      customize: "ปรับแต่ง",
      publish: "เผยแพร่",
      actions: "การดำเนินการ"
    }
  },

  // Analytics section
  analytics: {
    title: "การวิเคราะห์",
    timePeriods: {
      last7days: "7 วันที่แล้ว",
      last30days: "30 วันที่แล้ว"
    },
    comparison: {
      compareToPrevious: "เปรียบเทียบกับช่วงที่แล้ว",
      stopComparing: "หยุดเปรียบเทียบกับช่วงที่แล้ว"
    },
    sections: {
      searchLocations: "ค้นหาสถานที่"
    },
    cards: {
      sessions: "การเข้าถึง",
      topSearches: "คำค้นหาที่นิยมที่สุด",
      topLandingPageType: "ประเภทหน้าคลินิกที่นิยมที่สุด",
      topPageViewsBySession: "หน้าที่มองเห็นต่อการเข้าถึง",
      topLocations: "สถานที่ที่นิยมที่สุด",
      topReferrers: "การอ้างอิงที่นิยมที่สุด",
      searches: "ค้นหา",
      topLandingPagesBySession: "หน้าคลินิกที่มองเห็นต่อการเข้าถึง"
    },
    chartLabels: {
      desktop: "เดสก์ท็อป"
    }
  },

}; 